<template>
  <v-app-bar :color="headerColor" app>
    <img id="logo" src="@/assets/shield.svg" alt="Covenant Logo" style="height:40px;margin-right:1em;" />
    <v-toolbar-title class="headline">Scots Connect</v-toolbar-title>
    <span v-if="sectionTitle && path.substr(0, 15) === '/admin/preview/'" style="margin: 5px 0 0 1em">{{ sectionTitle }}</span>
    <v-spacer></v-spacer>
    <term-selector v-if="pathInAdmin"></term-selector>
    <v-menu v-if="pathInAdmin" bottom left offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" outlined>
          <v-icon left>fas fa-caret-down</v-icon>
          Navigation
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item :disabled="path === '/admin'" @click="$router.push('/admin')">
          <v-list-item-title>Admin Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="path === '/admin/sections'" @click="$router.push('/admin/sections')">
          <v-list-item-title>Section List</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" :disabled="path === '/admin/tracker'" @click="$router.push('/admin/tracker')">
          <v-list-item-title>Progress Tracker</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" :disabled="path === '/admin/advising/schedule'" @click="$router.push('/admin/advising/schedule')">
          <v-list-item-title>Advising Schedule</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" :disabled="path === '/admin/terms'" @click="$router.push('/admin/terms')">
          <v-list-item-title>Term Manager</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://docs.google.com/document/d/1qHzRbfcJh3c40jPkFo-YOElXArxyLfvr7rZEou3IHIY/view" target="_blank">
          <v-list-item-title>Scots Connect Admin Documentation</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <template v-else>
      <v-tooltip v-if="!isRoot" bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon aria-label="Return to the Scots Connect home page" @click="$router.push('/')">
            <v-icon>fas fa-home</v-icon>
          </v-btn>
        </template>
        <span>Return to the Scots Connect home page</span>
      </v-tooltip>
      <v-btn v-if="!hasRole(user, 'Parent')" icon aria-label="Open To-Do List" @click="openToDoList">
        <v-badge v-if="activeToDos.length > 0 && hasUnseenToDos" color="red" dot overlap>
          <v-icon v-if="shakeActive" class="shake">fas fa-bell-on</v-icon>
          <v-icon v-else>fas fa-bell</v-icon>
        </v-badge>
        <v-icon v-else-if="activeToDos.length > 0">fas fa-bell</v-icon>
        <v-icon v-else>fal fa-bell</v-icon>
      </v-btn>
      <!-- <v-menu v-model="todoMenu" :close-on-content-click="false" bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" aira-label="Action Menu">
            <v-badge v-if="activeToDos.length > 0 && hasUnseenToDos" color="red" dot overlap>
              <v-icon v-if="shakeActive" class="shake">fas fa-bell-on</v-icon>
              <v-icon v-else-if="activeToDos.length > 0 && newAction">fas fa-bell</v-icon>
            </v-badge>
            <v-icon v-else-if="activeToDos.length > 0">fas fa-bell</v-icon>
            <v-icon v-else>fal fa-bell</v-icon>
          </v-btn>
        </template>
        <v-card style="width:350px;max-width:100%">
          <v-toolbar dense>
            <v-toolbar-title>To-Do List</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="todoMenu = false">
              <v-icon>fal fa-times</v-icon>
            </v-btn>
          </v-toolbar>
          <v-tabs v-model="todoTab">
            <v-tab>
              <v-badge v-if="activeToDos.length > 0" :content="activeToDos.length">Active</v-badge>
              <span v-else>Active</span>
            </v-tab>
            <v-tab :disabled="dismissedToDos.length === 0">
              <v-badge v-if="dismissedToDos.length > 0" :content="dismissedToDos.length">Dismissed</v-badge>
              <span v-else>Dismissed</span>
            </v-tab>
            <v-tab :disabled="doneToDos.length === 0">
              <v-badge v-if="doneToDos.length > 0" :content="doneToDos.length">Done</v-badge>
              <span v-else>Done</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="todoTab">
            <v-tab-item>
              <v-list>
                <v-list-item v-for="(item, index) in activeToDos" :key="'activeToDo-' + index" @click="openLink(item.link)">
                  <v-list-item-title style="white-space:normal">{{ item.title }}</v-list-item-title>
                  <v-list-item-action>
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon>
                          <v-icon>fal fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click="openLink(item)">Go To Link</v-list-item>
                        <v-list-item @click="dismissAction(item)">Dismiss Item</v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="activeToDos.length === 0">
                  <v-list-item-title style="white-space:normal">There is currently nothing on your to-do list.</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list>
                <v-list-item v-for="({ title, link }, index) in dismissedToDos" :key="'dismissedToDo-' + index" @click="openLink(link)">
                  <v-list-item-title style="white-space:normal">{{ title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list>
                <v-list-item v-for="({ title, link }, index) in doneToDos" :key="'doneToDo-' + index">
                  <v-list-item-title style="white-space:normal">{{ title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-menu> -->
    </template>
    <v-menu v-if="isLoggedIn" bottom left offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" aria-label="User Menu">
          <v-icon>fas fa-user-circle</v-icon>
        </v-btn>
      </template>
      <v-toolbar dense>
        <v-toolbar-title>Logged in as: {{ username }}</v-toolbar-title>
      </v-toolbar>
      <v-list>
        <template v-if="isEmployee">
          <v-list-item v-if="!pathInAdmin" to="/admin">
            <v-list-item-title>Go to Admin Page</v-list-item-title>
          </v-list-item>
          <v-list-item v-else-if="hasTestAccount" to="/">
            <v-list-item-title>Go to Student Home</v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click="createTestAccount">
            <v-list-item-title>Create Test Account</v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item @click="darkMode = !darkMode">
          <v-list-item-title>{{ darkMode ? 'Enable Light Mode' : 'Enable Dark Mode' }}</v-list-item-title>
          <v-list-item-action>
            <v-icon>fas fa-adjust</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
          <v-list-item-action>
            <v-icon>fal fa-sign-out-alt</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn v-else to="/login">
      <v-icon left>fal fa-user-circle</v-icon>
      <span>Log In</span>
    </v-btn>
    <v-snackbar v-model="showTimer" :timeout="-1" top right>
      Auto-lock in: {{ timer }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="refreshTimeout" v-bind="attrs">Refresh</v-btn>
      </template>
    </v-snackbar>
  </v-app-bar>
</template>
<style>
.v-snack .v-snack__wrapper {
  z-index: 1000
}
.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%, 30%, 50%, 70%, 90% {
    transform: rotate(15deg) translateY(-3px);
  }
  20%, 40%, 60%, 80% {
    transform: rotate(-15deg) translateY(-3px);
  }
}
</style>
<script>
import { hasRole } from '../../helpers/has'
import { ref, computed, watch, onMounted, onUnmounted } from '@vue/composition-api'
import { setInterval } from 'timers'

export default {
  components: {
    TermSelector: () => import('@/components/admin/termSelector')
  },
  setup (props, { root }) {
    const interval = ref(null)
    const timer = ref('')
    const showTimer = ref(false)
    const user = computed(() => root.$store.state.user)
    const username = computed(() => user.value.username || '')
    const headerColor = computed(() => root.$vuetify.theme.dark ? '#193264' : '')
    const isLoggedIn = computed(() => root.$store.state.loggedIn || false)
    const path = computed(() => root.$route.path.toLowerCase())

    const sectionTitle = ref('')
    watch(path, (val) => {
      if (val.toLowerCase().substr(0, 6) === '/admin' && val !== '/admin' && root.$store.state.admin.term !== '') {
        root.$feathers.service('orientation/section').find({ query: { term: root.$store.state.admin.term, code: root.$route.params.section } }).then(({ data }) => {
          if (data.length > 0) {
            sectionTitle.value = data[0].label
          }
        })
      } else {
        sectionTitle.value = null
      }
    })
    const pathInAdmin = computed(() => root.$route.path.toLowerCase().split('/')[1] === 'admin')
    const isAdmin = computed(() => root.$store.getters.isAdmin)
    const isRoot = computed(() => root.$route.path === '/')

    const canSpoof = computed(() => root.$store.getters.hasRole('Technology Services'))

    const spoof = computed(() => root.$store.state.user.spoof || false)

    const endSpoof = () => {
      root.$feathers.service('system/spoof').remove(spoof.value._id).then((user) => {
        root.$store.commit('setUser', user)
        root.$store.commit('setRoles', user.roles)
        root.$router.push('/system/spoof')
      })
    }

    const darkMode = computed({
      get: () => root.$store.state.settings.darkMode || false,
      set: (value) => root.$store.dispatch('updateUserSetting', { field: 'darkMode', value })
    })

    function updateTimer () {
      const time = new Date().getTime()
      const timeDiff = (parseInt(root.$store.state.lastActivity) + 1800200 - time) / 1000
      if (timeDiff < 0) {
        logout()
        return
      }
      const mins = Math.floor(timeDiff / 60)
      const secs = Math.floor(timeDiff % 60)
      timer.value = mins + ':' + (secs < 10 ? '0' : '') + secs

      if (timer.value <= 0) {
        showTimer.value = false
        logout()
      } else {
        showTimer.value = mins < 5
      }
    }
    function logout () {
      root.$feathers.logout().then(() => {
        root.$store.dispatch('logout')
      })
    }
    function refreshTimeout () {
      root.$store.commit('updateActivity')
      showTimer.value = false
    }

    onMounted(() => {
      interval.value = setInterval(updateTimer, 1000)
    })
    onUnmounted(() => {
      clearInterval(interval.value)
    })

    const shakeActive = ref(false)
    watch(shakeActive, () => {
      if (shakeActive.value) {
        setTimeout(() => { shakeActive.value = false }, 820)
      }
    })

    // const todoTab = ref(0)
    const hasUnseenToDos = computed(() => {
      for (let i = 0; i < root.$store.state.actions.length; i++) {
        if (!root.$store.state.actions[i].viewed) {
          return true
        }
      }
      return false
    })
    const activeToDos = computed(() => {
      let arr = []
      let actions = root.$store.state.actions
      for (let i = 0; i < actions.length; i++) {
        if (!actions[i].done && !actions[i].dismissed) {
          arr.push({ ...actions[i], index: i })
        }
      }
      return arr
    })
    // const dismissedToDos = computed(() => {
    //   let arr = []
    //   for (let i = 0; i < root.$store.state.actions.length; i++) {
    //     if (root.$store.state.actions[i].dismissed) {
    //       arr.push({ ...root.$store.state.actions[i], index: i })
    //     }
    //   }
    //   return arr
    // })
    // const doneToDos = computed(() => {
    //   let arr = []
    //   for (let i = 0; i < root.$store.state.actions.length; i++) {
    //     if (root.$store.state.actions[i].done) {
    //       arr.push({ ...root.$store.state.actions[i], index: i })
    //     }
    //   }
    //   return arr
    // })
    const newAction = computed(() => {
      let dt = new Date()
      dt.setHours(dt.getHours() - 2)
      for (let i = 0; i < activeToDos.value.length; i++) {
        if ('added' in activeToDos.value[i]) {
          let temp = new Date(activeToDos.value[i].added)
          if (temp > dt) {
            return true
          }
        }
      }
      return false
    })
    watch(newAction, (val) => {
      if (val) {
        shakeActive.value = true
      }
    })

    // const todoMenu = ref(false)

    // function openLink (link) {
    //   if (link.substr(0, 1) === '/') root.$store.commit('setLink', link)
    //   else window.open(link, '_blank')
    //   todoMenu.value = false
    // }
    // function dismissAction (item) {
    //   root.$feathers.service('orientation/tracker').patch(root.$store.state.tracker.id, { ['actions.' + item.index + '.dismissed']: true }).then(({ actions }) => {
    //     root.$store.commit('setActions', actions)
    //   })
    // }

    const isEmployee = computed(() => hasRole(user.value, 'Employee'))

    const hasTestAccount = computed(() => hasRole(user.value, 'Employee') && root.$store.state.tracker.id !== '')

    const trackerService = root.$feathers.service('orientation/tracker')

    function createTestAccount () {
      root.$feathers.service('orientation/section').find({ query: { term: root.$store.state.admin.term, order: 1 } }).then(({ data }) => {
        const section = data[0].code
        trackerService.create({
          pidm: user.value.pidm,
          preferred: user.value.preferred,
          last: user.value.last,
          username: user.value.username,
          email: user.value.email,
          isTest: true,
          term: root.$store.state.admin.term,
          sections: [{
            section,
            status: 'Ready'
          }],
          blocks: [],
          actions: []
        }).then(() => {
          root.$store.dispatch('loadTracker')
          root.$store.dispatch('snackbar', { active: true, color: 'success', timeout: 5000, text: 'Test Account Created', actionText: 'Go To Student Home', action: 'to:/' })
        })
      })
    }

    function openToDoList () {
      if (root.$vuetify.breakpoint.mdAndDown) {
        // Scroll to the bottom of the page
        let height = document.getElementsByTagName('aside')[0].clientHeight
        window.scrollTo(0, document.body.scrollHeight - (height * 2) || document.documentElement.scrollHeight - (height * 2))
      } else {
        window.scrollTo(0, 0)
      }
      root.$store.commit('setActionNavBarActive', true)
    }

    return {
      interval,
      timer,
      showTimer,
      user,
      username,
      headerColor,
      isLoggedIn,
      path,
      sectionTitle,
      pathInAdmin,
      isAdmin,
      isRoot,
      canSpoof,
      spoof,
      endSpoof,
      darkMode,
      updateTimer,
      logout,
      refreshTimeout,
      // todoTab,
      hasUnseenToDos,
      activeToDos,
      // doneToDos,
      // dismissedToDos,
      newAction,
      isEmployee,
      hasTestAccount,
      createTestAccount,
      openToDoList,
      // todoMenu,
      // openLink,
      // dismissAction,
      shakeActive,
      hasRole
    }
  }
}
</script>
